import script from "./BoxEditDataTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxEditDataTab.vue?vue&type=script&setup=true&lang=js"

import "./BoxEditDataTab.vue?vue&type=style&index=0&id=c202cef2&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c202cef2"]])

export default __exports__